<template>
  <div class="wrapper">
    <EditMenu :loading="loading" :items="searchResult.items" />
  </div>
</template>

<script>
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdvertiser } from '@/mixins/setDrawerTypeAdvertiser'
import { setToolbarTypeAdvertiser } from '@/mixins/setToolBarTypeAdvertiser'
import EditMenu from '@/components/Advertiser/Menu/EditMenu'
export default {
  name: 'AdvertiserMenu',
  components: { EditMenu },
  mixins: [
    accountInitializer,
    setDrawerTypeAdvertiser,
    setToolbarTypeAdvertiser,
  ],
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    searchResult() {
      return this.$store.getters['menu/searchResult']
    },
  },
  async created() {
    this.initMenuList({})
  },
  methods: {
    async initMenuList() {
      this.loading = true
      await this.$store.dispatch(
        'menu/SEARCH_FOR_SIMULATION_PLAN',
        this.$route.params.advertiserId,
        0,
      )
      this.loading = false
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
}
</style>
